import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { pendingCheckoutStatusText } from '../utils/elemisCheckoutStatusText';

export interface UseElemisCheckoutPendingToastOptions {
    quoteId: string | undefined;
    isInitiating: boolean;
    isSlow: boolean;
    isVerySlow: boolean;
}

const toastIdFor = (quoteId: string | undefined) => `elemis-checkout-pending-${quoteId ?? 'unsaved'}`;

export function useElemisCheckoutPendingToast({
    quoteId,
    isInitiating,
    isSlow,
    isVerySlow,
}: UseElemisCheckoutPendingToastOptions): void {
    useEffect(() => {
        if (!isInitiating) {
            return;
        }
        const toastId = toastIdFor(quoteId);
        toast.loading(pendingCheckoutStatusText(false, false), {
            toastId,
            role: 'status',
            position: 'bottom-right',
            autoClose: false,
            closeButton: false,
            closeOnClick: false,
            draggable: false,
        });
        return () => {
            toast.dismiss(toastId);
        };
    }, [quoteId, isInitiating]);

    useEffect(() => {
        if (!isInitiating || (!isSlow && !isVerySlow)) {
            return;
        }
        toast.update(toastIdFor(quoteId), { render: pendingCheckoutStatusText(isSlow, isVerySlow) });
    }, [quoteId, isInitiating, isSlow, isVerySlow]);
}
